








//import { alarm, sensor } from "@/store";
import { defineComponent, onMounted } from "@vue/composition-api";

export default defineComponent({
    name: "Settings",
    components: {
        MyBoat: () =>
            import(/* webpackChunkName: "components" */ "./components/MyBoat.vue"),
        SystemStatus: () =>
            import(/* webpackChunkName: "components" */ "./components/SystemStatus.vue"),
        Control: () =>
            import(/* webpackChunkName: "components" */ "./components/Control.vue"),
        Sensors: () =>
            import(/* webpackChunkName: "components" */ "./components/SensorList.vue")
    },
    setup() {
        onMounted(() => {
            //sensor.GetData();
        });
    }
});
